import { Component } from '@angular/core';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { TpvTicketDiscountRestaurantticketPage } from '../../../tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-discount-restaurantticket/tpv-ticket-discount-restaurantticket';
import { TpvTicketInviteDiscountElementPage } from '../../../tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-invite-discount-element/tpv-ticket-invite-discount-element';
import { TakeawayOrderDiscountRestaurantticketPage } from '../../../takeaway/takeaway-order-discount-restaurantticket/takeaway-order-discount-restaurantticket';
import { TakeawayOrderInviteDiscountElementPage } from '../../../takeaway/takeaway-order-invite-discount-element/takeaway-order-invite-discount-element';


/**
 * Generated class for the PopupSelectDiscount page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-select-discount',
  templateUrl: 'popup-select-discount.html',
})
export class PopupSelectDiscount {
  type: any;
  public firestore: any;


  constructor(
    public globals: Globals,
    public translate: TranslateService,
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,) {
    this.type = this.navParams.get('type');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  discount() {
    if (this.type == 'table') {
      this.navCtrl.push(TpvTicketDiscountRestaurantticketPage, {
        type: 'discount'
      });
    } else {
      this.navCtrl.push(TakeawayOrderDiscountRestaurantticketPage, {
        type: 'discount'
      });
    }
  }

  restaurantTicket() {
    if (this.type == 'table') {
      this.navCtrl.push(TpvTicketDiscountRestaurantticketPage, {
        type: 'restaurantticket'
      });
    } else {
      this.navCtrl.push(TakeawayOrderDiscountRestaurantticketPage, {
        type: 'restaurantticket'
      });
    }
  }

  invite() {
    if (this.type == 'table') {
      this.navCtrl.push(TpvTicketInviteDiscountElementPage, {
        type: 'invite'
      });
    } else {
      this.navCtrl.push(TakeawayOrderInviteDiscountElementPage, {
        type: 'invite'
      });
    }
  }

  lineDiscount() {
    if (this.type == 'table') {
      this.navCtrl.push(TpvTicketInviteDiscountElementPage, {
        type: 'discount'
      });
    } else {
      this.navCtrl.push(TakeawayOrderInviteDiscountElementPage, {
        type: 'linediscount'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-select-discount/popup-select-discount.ts